/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('slideshow-component').forEach((slider) => {
      // console.log('slider', slider);
      function getFlickityInstance(slider) {
        return (window.theme.Flickity && window.theme.Flickity.data(slider)) || null;
      }
      const flkty = getFlickityInstance(slider);

      if (!flkty) return;

      slider.querySelectorAll('.custom-prev').forEach((btn) => {
        btn.addEventListener('click', () => flkty.previous());
      });

      slider.querySelectorAll('.custom-next').forEach((btn) => {
        btn.addEventListener('click', () => flkty.next());
      });

      // Click any dot -> go to slide
      slider.querySelectorAll('.custom-dot').forEach((dot) => {
        dot.addEventListener('click', () => {
          flkty.select(parseInt(dot.dataset.index, 10));
        });
      });

      // Update active dot in ALL dot containers
      const updateDots = (index) => {
        slider.querySelectorAll('.custom-page-dots').forEach((container) => {
          const dots = container.querySelectorAll('.custom-dot');

          dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === index);

            if (i === index) {
              dot.setAttribute('aria-current', 'step');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        });
      };

      // Initial active state
      updateDots(flkty.selectedIndex);

      // On slide change
      flkty.on('change', updateDots);
    });
  });
function initPredictiveSearchSlider() {
  document.querySelectorAll('.js-search-featured-slider').forEach((slider) => {
    // if (slider.flickity) return;

    slider.flickity = new window.theme.Flickity(slider, {
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false
    });

    requestAnimationFrame(() => {
      slider.flickity.reloadCells();
      slider.flickity.resize();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initPredictiveSearchSlider();

  const body = document.body;

  const observer = new MutationObserver(() => {
    if (body.classList.contains('search-opened')) {
      // Predictive search content renders async — wait for the cells to actually exist
      // const checkExist = setInterval(() => {
        const sliders = document.querySelectorAll('.js-search-featured-slider .carousel-cell');
        if (sliders.length) {
          // clearInterval(checkExist);
          initPredictiveSearchSlider();
        }
      // }, 1000);
    }
  });

  observer.observe(body, {
    attributes: true,
    attributeFilter: ['class']
  });
});

(function() {
  // Add custom code below this line


// Best selling option on Sort By Button - Collection Page
document.addEventListener('DOMContentLoaded', () => {
  const customLabel = document.querySelector('.custom_sort_option_label');
  const checkedInput = document.querySelector('.collection__sort__input:checked');

  if (!customLabel || !checkedInput) return;

  const optionLabel = document.querySelector(`label[for="${checkedInput.id}"]`);

  if (optionLabel) {
    customLabel.textContent = optionLabel.textContent.trim();
  }
});

document.querySelectorAll('.collection__sort__input').forEach(input => {
  input.addEventListener('change', () => {
    const customLabel = document.querySelector('.custom_sort_option_label');
    const optionLabel = document.querySelector(`label[for="${input.id}"]`);

    if (customLabel && optionLabel) {
      customLabel.textContent = optionLabel.textContent.trim();
    }
  });

  const url = new URL(window.location);

  if (!url.searchParams.has('sort_by')) {
    url.searchParams.set('sort_by', 'best-selling');
    window.location.replace(url.toString());
  }
});

// Visual Guide popup 
// Visual Guide popup
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById("visualGuideModal");
  const openBtn = document.getElementById("openVisualGuide");

  if (!modal || !openBtn) return;

  openBtn.addEventListener("click", function (e) {
    e.preventDefault();
    modal.classList.add("active");
    document.body.style.overflow = "hidden";
  });

  function closeGuide() {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }

  const closeBtn = modal.querySelector(".visual-guide-close");
  const overlay = modal.querySelector(".visual-guide-modal__overlay");

  if (closeBtn) closeBtn.addEventListener("click", closeGuide);
  if (overlay) overlay.addEventListener("click", closeGuide);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeGuide();
  });
});


// Product sepcs

function updateProductSpecs(variantId) {
  if (!variantId) return;

  document.querySelectorAll('script[id^="product-specs-data-"]').forEach((dataEl) => {
    let specsByVariant;
    try {
      specsByVariant = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    // This variant doesn't belong to this product's data block — skip it
    if (!(variantId in specsByVariant)) return;

    const productId = dataEl.id.replace('product-specs-data-', '');
    const container = document.getElementById(`product-specs-${productId}`);
    if (!container) return;

    const specs = specsByVariant[variantId] || [];

    if (!specs.length) {
      container.innerHTML = '';
      return;
    }

    container.innerHTML = specs.map(spec => `
      <div class="product-spec">
        ${spec.icon ? `<img src="${spec.icon}" loading="lazy" alt="${spec.text || ''}" class="product-spec__icon" width="20">` : ''}
        ${spec.text ? `<span class="product-spec__text">${spec.text}</span>` : ''}
      </div>
    `).join('');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe === 'function' && window.theme?.PUB_SUB_EVENTS?.variantChange) {
    subscribe(theme.PUB_SUB_EVENTS.variantChange, function (event) {
      const variant = event?.data?.variant;
      if (variant && variant.id) {
        updateProductSpecs(String(variant.id));
      }
    });
  } else {
    console.warn('Product specs: subscribe/theme.PUB_SUB_EVENTS not available');
  }
});



// Size guide
document.addEventListener('DOMContentLoaded', function () {
  var openBtn = document.getElementById('sizeGuideOpen');
  var closeBtn = document.getElementById('sizeGuideClose');
  var overlay = document.getElementById('sizeGuideOverlay');
  var modal = document.getElementById('sizeGuideModal');

  if (!modal) return;

  function openModal() {
    modal.classList.add('is-open');
  }

  function closeModal() {
    modal.classList.remove('is-open');
  }

  if (openBtn) openBtn.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (overlay) overlay.addEventListener('click', closeModal);
});


// Mmobile menu Accrodion
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.drawer-text').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));

      var content = document.getElementById(trigger.getAttribute('aria-controls'));
      if (content) content.classList.toggle('is-closed', expanded);
    });
  });
});



// Empty cart drawer
(function () {
  function updateVisibility() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelector('.cart__widgets')
          ?.classList.toggle('hidden', cart.item_count === 0);
      });
  }

  document.addEventListener('DOMContentLoaded', updateVisibility);

    const _fetch = window.fetch;
    window.fetch = (...args) => {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      const p = _fetch(...args);
      if (/\/cart\/(add|update|change|clear)/.test(url)) p.then(updateVisibility);
      return p;
    };
  })();



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
